export const systemuuid={
  DAIRYREPORT : "00000000-0000-0000-0000-000000010001",
  ATTENDANCE  : "00000000-0000-0000-0000-000000010002",
  QUOTATION   : "00000000-0000-0000-0000-000000010003",
  INVOICE     : "00000000-0000-0000-0000-000000010004",
  TAKUMIPAD   : "00000000-0000-0000-0000-000000010005",
  PHOTOBOOK   : "00000000-1000-0000-0000-000000010006",
  ANDES       : "00000000-1000-0000-0000-000000020001",
  TAKUMI_PAD  : "00000000-1000-0000-0000-000000030001",
  ANDES_BACKUP: "00000000-0000-0000-0000-000000000003",
  LOCAL_CONFIG_MANAGE:"00000000-0000-0000-0000-000000000010",
  WHITE_BOARD : "00000000-0000-0000-0000-000000010007",
}

/**
 * 契約有無の判定関数
 * @param {*} systemuuidval 
 * @returns 
 */
export const hasContractOption=(systemuuidval)=>{
  const contractOptionsJson = localStorage.getItem("contractUuids");
  const contractOptionList = [];
  if(contractOptionsJson){
    contractOptionList.push(...JSON.parse(contractOptionsJson));
  }

  //　契約情報がない場合は空を返す
  if(contractOptionList.length===0)return false;

  if(contractOptionList.includes(systemuuidval)){
    // 契約情報一覧にあるのであれば契約ありで返す
    return true;
  }
  return false;
}
